import * as models from './model';
export interface IPaginationRequest {
    pageSize: number;
    pageNumber: number;
}
